import React from "react";
import "./Filters.scss";
import SearchAdditionalInstitutionInput from "./SearchAdditionalInstitutionInput";

const AdditionalInstitutions = ({
  isAddRemoveInProgress,
  setIsAddRemoveInProgress,
}) => {
  return (
    <div className="filters">
      <div className="filter-section">
        <div className="header-section">
          <label>Additional Institution</label>
          <span>
            Manually add institutions that fall outside the filter criteria.
          </span>
        </div>
        <SearchAdditionalInstitutionInput
          isAddRemoveInProgress={isAddRemoveInProgress}
          setIsAddRemoveInProgress={setIsAddRemoveInProgress}
        />
      </div>
    </div>
  );
};

export default AdditionalInstitutions;
